var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.itemArr),function(item,index){return _c('div',{key:index},[_c('certification-item',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }